import state from './module-misaid-state';
import mutations from './module-misaid-mutations';
import actions from './module-misaid-actions';
import getters from './module-misaid-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
